import { call, select, takeEvery } from 'redux-saga/effects';
import {
  DoRequestResponse,
  GlobalAction,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
  ProduktRequested,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { PS20Logger } from '@ps20-frontend/logging';
import { GegenstandResponseModel } from '@ps20/bff-models';
import { IAppState } from '../appState';

const globalActions = new GlobalActions();

export enum GegenstaendeCategoriesRequestEvents {
  GEGENSTAENDE_CATEGORIES_REQUEST_SUCCESSFUL = 'GEGENSTAENDE_CATEGORIES_REQUEST_SUCCESSFUL',
  GEGENSTAENDE_CATEGORIES_REQUEST_FAILED = 'GEGENSTAENDE_CATEGORIES_REQUEST_FAILED',
}

export function* watchGegenstaendeCategoriesRequested() {
  yield takeEvery(GlobalActions.PRODUKT_REQUESTED, safeSaga(callGegenstaendeCategories, App.GEGE));
  yield takeEvery(
    GegenstaendeCategoriesRequestEvents.GEGENSTAENDE_CATEGORIES_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.GEGE),
  );
  yield takeEvery(
    GegenstaendeCategoriesRequestEvents.GEGENSTAENDE_CATEGORIES_REQUEST_FAILED,
    safeSaga(errorCallback, App.GEGE),
  );
}

export function* callGegenstaendeCategories(action: GlobalAction<ProduktRequested>) {
  const globalPut = GlobalPut.getInstance();
  const state: IAppState = yield select();
  if (
    state.angebotsId === action.payload.angebotsId &&
    App.GEGE === action.payload.appId &&
    !state.gegenstandsschutz.categories?.length
  ) {
    yield call(
      [globalPut, globalPut.put],
      globalActions.doRequest({
        appId: App.GEGE,
        url: 'privatschutz/api/gegenstaende',
        method: HTTP_METHOD.GET,
        successEvent:
          GegenstaendeCategoriesRequestEvents.GEGENSTAENDE_CATEGORIES_REQUEST_SUCCESSFUL,
        errorEvent: GegenstaendeCategoriesRequestEvents.GEGENSTAENDE_CATEGORIES_REQUEST_FAILED,
      }),
    );
  }
}

export function* successCallback(successAction: DoRequestResponse<GegenstandResponseModel>) {
  const globalPut = GlobalPut.getInstance();

  yield call(
    globalPut.put,
    globalActions.gegenstaendeCategoriesReceived(successAction.payload.gegenstaende),
  );
}

export function errorCallback(errorAction: DoRequestResponse<GegenstandResponseModel>) {
  PS20Logger.error(
    App.SHOP,
    'Loading gegenstaende from bff failed.',
    errorAction.payload.toString(),
  );
}
